var map = {
	"./amex.svg": "3ce8",
	"./avatar.svg": "56fcc",
	"./calendar.svg": "4fef",
	"./checked-box-green.svg": "2225",
	"./chevron-orange.svg": "f624",
	"./discover.svg": "4a33",
	"./down-arrow.svg": "9367",
	"./file_management.svg": "d2ad",
	"./filter.svg": "c86e",
	"./flags/china.svg": "4b36",
	"./flags/france.svg": "08bb",
	"./flags/germany.svg": "aac1",
	"./flags/greece.svg": "1ea1",
	"./flags/italy.svg": "0834",
	"./flags/sweden.svg": "80dc",
	"./flags/uk.svg": "b5c9",
	"./flags/usa.svg": "9d60",
	"./google.svg": "ccc8",
	"./icon-arrow-down.svg": "c611",
	"./icon-arrow-left-active.svg": "420f",
	"./icon-arrow-left-inactive.svg": "1fe8",
	"./icon-arrow-right-active.svg": "97aa",
	"./icon-arrow-right-inactive.svg": "f300",
	"./icon-arrow-right-small.svg": "9575",
	"./icon-arrow-up.svg": "7552",
	"./icon-arrow.svg": "ec46",
	"./icon-burger.svg": "611a",
	"./icon-calendar.svg": "ab8e",
	"./icon-chart-flow.svg": "860c",
	"./icon-chart-pie.svg": "5dd0",
	"./icon-chevron-down-dark.svg": "cf64",
	"./icon-chevron-down.svg": "06fa",
	"./icon-circle.svg": "0ce2",
	"./icon-clock.svg": "00be",
	"./icon-close.svg": "ffed",
	"./icon-cog.svg": "2da8",
	"./icon-edit.svg": "c92f",
	"./icon-email.svg": "5ddd",
	"./icon-location.svg": "05b6",
	"./icon-lock-wide.svg": "077b",
	"./icon-lock.svg": "b202",
	"./icon-mail-white.svg": "bc77",
	"./icon-mail-wide.svg": "e5ef",
	"./icon-mail.svg": "0265",
	"./icon-paper-plane.svg": "bf25",
	"./icon-previous.svg": "6f93",
	"./icon-skip-end-active.svg": "7a33",
	"./icon-skip-end-inactive.svg": "7e05",
	"./icon-skip-start-active.svg": "92ba",
	"./icon-skip-start-inactive.svg": "41e1",
	"./icon-speaker.svg": "b2f8",
	"./icon-star.svg": "74f0",
	"./icon-users.svg": "7ae3",
	"./jcb.svg": "193a",
	"./list-dropdown-bg.svg": "a857",
	"./logo-jolahr-large.svg": "c770",
	"./logo-jolahr-small.svg": "0b92",
	"./mastercard.svg": "29b8",
	"./microsoft.svg": "6038",
	"./mobile-plus-icon.svg": "6acf",
	"./search.svg": "6f6b",
	"./triangle.svg": "c821",
	"./unchecked-box.svg": "1882",
	"./union_pay.svg": "a0d7",
	"./visa.svg": "6180",
	"./visible.svg": "d3ed",
	"./warning.svg": "449c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";